// extracted by mini-css-extract-plugin
module.exports = {"header":"styles-module__header___2h10_","title":"styles-module__title___1Nubx","edit":"styles-module__edit___2-i5I"};